/* BLACKLISTS */
export const GET_BLACKLISTS = "GET_BLACKLISTS"
export const GET_BLACKLISTS_SUCCESS = "GET_BLACKLISTS_SUCCESS"
export const GET_BLACKLISTS_FAIL = "GET_BLACKLISTS_FAIL"

/* BLACKLISTS DETAIL*/
export const GET_BLACKLIST_DETAIL = "GET_BLACKLIST_DETAIL"
export const GET_BLACKLIST_DETAIL_SUCCESS = "GET_BLACKLIST_DETAIL_SUCCESS"
export const GET_BLACKLIST_DETAIL_FAIL = "GET_BLACKLIST_DETAIL_FAIL"

/**
 * ADD BLACKLIST
 */
export const ADD_NEW_BLACKLIST = "ADD_NEW_BLACKLIST"
export const ADD_BLACKLIST_SUCCESS = "ADD_BLACKLIST_SUCCESS"
export const ADD_BLACKLIST_FAIL = "ADD_BLACKLIST_FAIL"

/**
 * EDIT BLACKLIST
 */
export const UPDATE_BLACKLIST = "UPDATE_BLACKLIST"
export const UPDATE_BLACKLIST_SUCCESS = "UPDATE_BLACKLIST_SUCCESS"
export const UPDATE_BLACKLIST_FAIL = "UPDATE_BLACKLIST_FAIL"

/**
 * CLEAR MESSAGE AND ERROR OBJECT
 */
export const CLEAR_MESSAGE = "CLEAR_MESSAGE"
